import { VCheckbox} from 'vuetify/lib'
import VModel from '@/vuetify_custom/v-modal_v1'
import {localstoragekey, noHandleArray} from '@/views/blogger/records/constatns.js'

export default {
    props: {
        list: {
            type: Array,
            default: () => ({})
        }
    },
    data() {
        return {
            dis: false,
            selected: []
        }
    },
    computed: {
    },

    methods: {
        edit() {
            this.dis = true
            let arr = localStorage.getItem(localstoragekey)
            arr = JSON.parse(arr)
           
            this.selected = arr || []
        },
        submit() {
            localStorage.setItem(localstoragekey, JSON.stringify(this.selected))
            this.dis = false
        }
    },
    render() {
        return <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        title="编辑"
        max-width="500"
       
        on={{
             ok: this.submit,
            cancel:  () => {
                this.dis = false
            }
        }}
       
    >
        {this.list.filter(i => !noHandleArray.includes(i.key)).map(item => {
            return <VCheckbox
                v-model={this.selected}
                label={item.label}
                value={item.key}
            />
        })}
        </VModel>
    }
}